import { useListContext } from "ra-core";
import { Fragment } from "react";
import { Separator } from "@/components/ui/separator";

import { InfinitePagination } from "../misc/InfinitePagination";
import { Note } from "./Note";
import { NoteCreate } from "./NoteCreate";

/** Note form followed by the existing notes, newest first. */
export const NotesIterator = ({
  reference,
}: {
  reference: "contacts" | "sponsorings";
}) => {
  const { isPending, error, data = [] } = useListContext();

  if (isPending || error) return null;

  return (
    <div className="mt-4">
      <NoteCreate reference={reference} />
      {data.length > 0 && (
        <div className="mt-6 flex flex-col gap-3">
          {data.map((note, index) => (
            <Fragment key={note.id}>
              {index > 0 && <Separator />}
              <Note note={note} />
            </Fragment>
          ))}
        </div>
      )}
      <InfinitePagination />
    </div>
  );
};
